module.exports = __webpack_public_path__ + "media/cuttlefish/arrowDown-8ae27f82.svg";